export type HolidayStatusKind = 'upcoming' | 'ongoing' | 'ended';

export const holidayStatus = (
  startDate: string,
  endDate: string,
  today: string,
): HolidayStatusKind => {
  if (today < startDate) return 'upcoming';
  if (today > endDate) return 'ended';
  return 'ongoing';
};
